<template>
  <div class="admin-container">
    <div class="header">
      <h1>纪检举报管理</h1>
      <div>
        <el-button type="primary" @click="pwdDialogVisible = true"
          >修改密码</el-button
        >
        <el-button type="danger" @click="handleLogout">退出登录</el-button>
      </div>
    </div>

    <div class="filter-box">
      <el-form :inline="true" :model="queryForm" class="filter-form">
        <el-form-item label="状态">
          <el-select
            v-model="queryForm.status"
            placeholder="全部"
            clearable
            style="width: 150px"
          >
            <el-option label="待处理" value="待处理" />
            <el-option label="处理中" value="处理中" />
            <el-option label="已处理" value="已处理" />
            <el-option label="已关闭" value="已关闭" />
          </el-select>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input
            v-model="queryForm.keyword"
            placeholder="搜索主要诉求、内容、被反映人"
            style="width: 300px"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadLetters">搜索</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-box">
      <el-table :data="letters" v-loading="loading" stripe style="width: 100%">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="purpose" label="写信目的" width="100" />
        <el-table-column
          prop="mainRequest"
          label="主要诉求"
          width="200"
          show-overflow-tooltip
        />
        <el-table-column prop="requestType" label="诉求方式" width="100" />
        <el-table-column prop="reportedPerson" label="被反映人" width="120" />
        <el-table-column prop="phoneNumber" label="手机号码" width="120" />
        <el-table-column prop="reporter" label="反映人" width="120" />
        <el-table-column prop="status" label="状态" width="100">
          <template #default="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180" />
        <el-table-column label="操作" width="300" fixed="right">
          <template #default="scope">
            <el-button
              type="primary"
              size="small"
              @click="viewDetail(scope.row)"
            >
              查看
            </el-button>
            <el-button
              type="success"
              size="small"
              @click="updateStatus(scope.row)"
            >
              更新状态
            </el-button>
            <el-button
              type="primary"
              size="small"
              @click="downloadFile(scope.row)"
              v-if="scope.row.attachments"
            >
              下载附件
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-box">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </div>

    <!-- 详情对话框 -->
    <el-dialog
      v-model="detailVisible"
      title="详情"
      width="80%"
      :before-close="closeDetail"
    >
      <div v-if="currentLetter" class="detail-content">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="ID">{{
            currentLetter.id
          }}</el-descriptions-item>
          <el-descriptions-item label="写信目的">{{
            currentLetter.purpose
          }}</el-descriptions-item>
          <el-descriptions-item label="主要诉求" :span="2">{{
            currentLetter.mainRequest
          }}</el-descriptions-item>
          <el-descriptions-item label="诉求方式">{{
            currentLetter.requestType
          }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="getStatusType(currentLetter.status)">{{
              currentLetter.status
            }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="被反映人">{{
            currentLetter.reportedPerson || "无"
          }}</el-descriptions-item>
          <el-descriptions-item label="单位职务">{{
            currentLetter.unitPosition || "无"
          }}</el-descriptions-item>
          <el-descriptions-item label="手机号码">{{
            currentLetter.phoneNumber
          }}</el-descriptions-item>
          <el-descriptions-item label="反映人">{{
            currentLetter.reporter || "匿名"
          }}</el-descriptions-item>
          <el-descriptions-item label="诉求详细内容" :span="2">
            <div class="content-text">{{ currentLetter.content }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间">{{
            currentLetter.createTime
          }}</el-descriptions-item>
          <el-descriptions-item label="更新时间">{{
            currentLetter.updateTime
          }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{
            currentLetter.remark || "无"
          }}</el-descriptions-item>
        </el-descriptions>

        <!-- <div
          v-if="
            currentLetter.attachments && currentLetter.attachments.length > 0
          "
          class="attachments-box"
        >
          <h3>附件列表</h3>
          <el-table :data="currentLetter.attachments" border>
            <el-table-column prop="fileName" label="文件名" />
            <el-table-column prop="fileType" label="文件类型" width="100" />
            <el-table-column prop="fileSize" label="文件大小" width="120">
              <template #default="scope">
                {{ formatFileSize(scope.row.fileSize) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template #default="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="downloadFile(scope.row)"
                >
                  下载
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div> -->
      </div>
    </el-dialog>

    <!-- 更新状态对话框 -->
    <el-dialog v-model="statusVisible" title="更新状态" width="500px">
      <el-form :model="statusForm" label-width="100px">
        <el-form-item label="状态">
          <el-select v-model="statusForm.status" style="width: 100%">
            <el-option label="待处理" value="待处理" />
            <el-option label="处理中" value="处理中" />
            <el-option label="已处理" value="已处理" />
            <el-option label="已关闭" value="已关闭" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="statusForm.remark"
            type="textarea"
            :rows="4"
            placeholder="请输入备注信息"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="statusVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmUpdateStatus">确定</el-button>
      </template>
    </el-dialog>

    <!-- 新增：修改密码弹窗 -->
    <el-dialog
      v-model="pwdDialogVisible"
      title="修改密码"
      width="450px"
      :close-on-click-modal="false"
      :before-close="closePwdDialog"
    >
      <el-form
        ref="pwdFormRef"
        :model="pwdForm"
        :rules="pwdFormRules"
        label-width="100px"
        class="pwd-form"
      >
        <el-form-item label="旧密码" prop="oldPwd">
          <el-input
            v-model="pwdForm.oldPwd"
            type="password"
            placeholder="请输入旧密码"
            show-password
          />
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input
            v-model="pwdForm.newPwd"
            type="password"
            placeholder="请输入6-18位新密码"
            show-password
          />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPwd">
          <el-input
            v-model="pwdForm.confirmPwd"
            type="password"
            placeholder="请再次输入新密码"
            show-password
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="closePwdDialog">取消</el-button>
        <el-button type="primary" @click="submitPwdChange">确定修改</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api/index";
// import api_test from "@/api/test";
import { formatNativeTime } from "@/components/verifition/utils/util";
export default {
  name: "AdminList",
  data() {
    const validateConfirmPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请确认新密码"));
      }
      if (value !== this.pwdForm.newPwd) {
        callback(new Error("两次输入的新密码不一致"));
      } else {
        callback();
      }
    };

    return {
      pwdDialogVisible: false,
      pwdForm: {
        // 密码表单数据
        oldPwd: "", // 旧密码
        newPwd: "", // 新密码
        confirmPwd: "", // 确认密码
      },
      // 新增：密码表单验证规则
      pwdFormRules: {
        oldPwd: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newPwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, max: 18, message: "新密码长度为6-18位", trigger: "blur" },
        ],
        confirmPwd: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: validateConfirmPwd, trigger: "blur" },
        ],
      },
      letters: [],
      loading: false,
      queryForm: {
        status: "",
        keyword: "",
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      detailVisible: false,
      currentLetter: null,
      statusVisible: false,
      statusForm: {
        status: "",
        remark: "",
        letterId: null,
      },
    };
  },
  mounted() {
    this.loadLetters();
    console.log(localStorage.getItem("adminUser_id"));
  },
  methods: {
    closePwdDialog() {
      this.pwdDialogVisible = false;
      this.pwdForm = {
        oldPwd: "",
        newPwd: "",
        confirmPwd: "",
      };
    },

    async submitPwdChange() {
      const params = {
        id: localStorage.getItem("adminUser_id"),
        oldPassword: this.pwdForm.oldPwd,
        newPassword: this.pwdForm.newPwd,
      };
      if (params.oldPassword && params.newPassword) {
        const res = await api.put("/auth/updatePassword", params);
        if (res.code == 200) {
          this.$message.success("密码修改成功");
          this.closePwdDialog();
        } else {
          this.$message.error(res.message || "密码修改失败");
        }
      }
    },

    handleBlobDownload(blobData, fileName) {
      // 创建 Blob 对象（适配不同文件类型）
      const blob = new Blob([blobData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx 专属 MIME 类型
      });
      // 创建下载链接
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileName; // 下载后的文件名
      document.body.appendChild(link);
      link.click(); // 触发下载
      // 清理资源
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      this.$message.success("文件下载成功");
    },
    async downloadFile(row) {
      const response = await api({
        method: "post",
        url: "/web/file/download",
        params: {
          path: row.attachments,
        },
        responseType: "blob",
      });
      this.handleBlobDownload(response.data, row.attachments);
    },
    //时间处理
    formatTime(time) {
      return formatNativeTime(time);
    },
    async loadLetters() {
      this.loading = true;
      try {
        const params = {
          status: this.queryForm.status || null,
          keyword: this.queryForm.keyword || null,
          page: this.currentPage - 1,
          size: this.pageSize,
        };
        const response = await api.get("/letter/list", { params });
        if (response.success) {
          this.letters = response.data.list || [];
          this.letters.forEach((letter) => {
            letter.createTime = this.formatTime(letter.createTime);
            letter.updateTime = this.formatTime(letter.updateTime);
          });
          this.total = response.data.total || 0;
        }
      } catch (error) {
        this.$message.error(
          error.response?.data?.message || "加载信件列表失败"
        );
      } finally {
        this.loading = false;
      }
    },
    resetQuery() {
      this.queryForm = {
        status: "",
        keyword: "",
      };
      this.currentPage = 1;
      this.loadLetters();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadLetters();
    },
    handlePageChange(val) {
      this.currentPage = val;
      this.loadLetters();
    },
    async viewDetail(row) {
      try {
        const response = await api.get(`/letter/${row.id}`);
        if (response.success) {
          this.currentLetter = response.data;
          this.currentLetter.createTime = this.formatTime(
            this.currentLetter.createTime
          );
          this.currentLetter.updateTime = this.formatTime(
            this.currentLetter.updateTime
          );

          // 附件信息已经在后端解析好了
          if (!this.currentLetter.attachments) {
            this.currentLetter.attachments = [];
          }
          this.detailVisible = true;
        } else {
          this.$message.error(response.message || "加载详情失败");
        }
      } catch (error) {
        this.$message.error(error.response?.data?.message || "加载详情失败");
      }
    },
    closeDetail() {
      this.detailVisible = false;
      this.currentLetter = null;
    },
    updateStatus(row) {
      this.statusForm.letterId = row.id;
      this.statusForm.status = row.status;
      this.statusForm.remark = row.remark || "";
      this.statusVisible = true;
    },
    async confirmUpdateStatus() {
      try {
        const response = await api.put(
          `/letter/${this.statusForm.letterId}/status`,
          {
            status: this.statusForm.status,
            remark: this.statusForm.remark,
          }
        );
        if (response.success) {
          this.$message.success(response.message || "状态更新成功");
          this.statusVisible = false;
          this.loadLetters();
        } else {
          this.$message.error(response.message || "更新失败");
        }
      } catch (error) {
        this.$message.error(error.response?.data?.message || "更新状态失败");
      }
    },

    getStatusType(status) {
      const typeMap = {
        待处理: "warning",
        处理中: "info",
        已处理: "success",
        已关闭: "danger",
      };
      return typeMap[status] || "";
    },
    formatFileSize(size) {
      if (size < 1024) return size + " B";
      if (size < 1024 * 1024) return (size / 1024).toFixed(2) + " KB";
      return (size / (1024 * 1024)).toFixed(2) + " MB";
    },
    handleLogout() {
      localStorage.removeItem("adminToken");
      this.$router.push("/admin/login");
    },
  },
};
</script>

<style scoped>
.admin-container {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header h1 {
  margin: 0;
  color: #333;
}

.filter-box {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.table-box {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.pagination-box {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.detail-content {
  max-height: 70vh;
  overflow-y: auto;
}

.content-text {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.6;
}

.attachments-box {
  margin-top: 20px;
}

.attachments-box h3 {
  margin-bottom: 15px;
  color: #333;
}

@media (max-width: 768px) {
  .admin-container {
    padding: 10px;
  }

  .header {
    flex-direction: column;
    align-items: flex-start;
  }

  .header h1 {
    margin-bottom: 10px;
  }
}
</style>

